import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { auth } from './config/firebaseInit'
import router from './router'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueComp from '@vue/composition-api';

// import VueSocketIO from 'vue-socket.io';

// Vue.use(new VueSocketIO({
//   connection: 'http://localhost:3000'
// }));
Vue.use(VueComp)

Vue.use(VueAxios, axios)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyARtcAswR2lYZwrcn5BJ2yJKPpL9V5-mY4',
    libraries: 'places' // necessary for places input
  }
})
Vue.config.productionTip = false

auth.onAuthStateChanged(user => {
  store.dispatch('fetchUser', user)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
